import BaseListagem from "components/BaseListagem";
import UnidadeOrganizacional from "model/indicadores/UnidadeOrganizacional";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useEffect, useState } from "react";
import SetorService from "service/administracao/cadastro/SetorService";
import { IdMatchModeOptions, TextMatchModeOptions, dropdownFilterTemplate, filterApplyTemplate } from "utils/filterUtils";

const setorService = new SetorService();

export default function SetorListagem() {

    const [unidades, setUnidades] = useState<UnidadeOrganizacional[]>([]);

    useEffect(() => {
        setorService.unidadesOrgan().then((resposta) => {
            setUnidades(resposta)
        }).catch((error) => {
            console.error("Erro ao buscar unidades organizacionais:", error);
        });
    }, [])

    const defaultFilters: DataTableFilterMeta = {
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        unidadeOrganizacional: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    return (

        <BaseListagem ordenacao="nome,ASC" service={setorService} urlService="/setor" tituloPagina={'Setor'} defaultFilters={defaultFilters} showClearFilterButton nome="setor" >
            <Column field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="unidadeOrganizacional.nome" header="Unid. Organ." filter filterField="unidadeOrganizacional" showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterTemplate(options, unidades)} />

        </BaseListagem>
    )
}
